import styled from "@emotion/styled";
import { Image, Button } from "react-bootstrap";
import { IStyledComponentProps } from "../../theme/theme.types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const HeaderContainer = styled.header<IStyledComponentProps>`
  &.header-container {
    background-color: ${(props) => props.theme.colors.brand.primary};
    height: 72px;

    .container {
      height: 100%;

      .row {
        height: 100%;
        align-items: center;

        .logo-column {
          align-items: center;
        }

        .nav-column {
          display: flex;
          justify-content: flex-end !important;
        }
      }
    }
  }
`;

const NavLinkButton = styled(Button)<IStyledComponentProps>`
  &.nav-link-button {
    appearance: none;
    background-color: transparent;
    border: 0 none;
    cursor: pointer;
    color: ${(props) => props.theme?.colors.essential.grayLight};

    font-family: ${(props) => props.theme?.fontFamilies?.regular};
    font-size: ${(props) => props.theme?.fontSizes?.smallest}px;
    padding: 0;
    &,
    &:hover,
    &:focus,
    &:active {
      color: ${({ theme }) => theme?.colors.essential.white};
    }

    &.mobile {
      text-align: center;
      .home-link-icon,
      .logout-link-icon {
        margin: 0 auto;
      }
    }
  }
`;

const Logo = styled(Image)<IStyledComponentProps>`
  height: 38px;
  width: 144px;
  left: 0px;
  top: 5.5px;
  border-radius: 0px; ;
`;

const HomeLinkIcon = styled(Image)<IStyledComponentProps>`
  &.home-link-icon {
    height: 11px;
    width: 16px;
  }
`;

const LogOutLinkIcon = styled(Image)<IStyledComponentProps>`
  &.logout-link-icon {
    height: 11px;
    width: 16px;
  }
`;

const BpAlertHeader = styled.header<IStyledComponentProps>`
  background-color: ${({ theme }) => theme?.colors.alerts.tertiaryLite};
  text-align: left;
  padding: 6px 24px;
  color: ${({ theme }) => theme?.colors.alerts.primary};
  border: 2px ${({ theme }) => theme?.colors.alerts.primary} solid;
`;

const BpBarHeader = styled.header<IStyledComponentProps>`
  background-color: ${({ theme }) => theme?.colors.essential.grayLight};
  text-align: center;
  padding: 6px 24px;
`;

const BpUserIcon = styled(FontAwesomeIcon)<IStyledComponentProps>`
  color: ${({ theme }) => theme?.colors.grays.tertiary};
  margin-right: 6px;
`;

const BpText = styled.span<IStyledComponentProps>`
  color: ${({ theme }) => theme?.colors.grays.septenary};
  font-family: ${({ theme }) => theme?.fontFamilies.semiBold};
  font-size: ${({ theme }) => theme?.fontSizes.smallest}px;
`;

const BpAlertIcon = styled(FontAwesomeIcon)<IStyledComponentProps>`
  color: ${({ theme }) => theme?.colors.alerts.primary};
  margin-right: 6px;
`;

const BpAlertText = styled.span<IStyledComponentProps>`
  color: ${({ theme }) => theme?.colors.alerts.primary};
  font-family: ${({ theme }) => theme?.fontFamilies.semiBold};
  font-size: ${({ theme }) => theme?.fontSizes.smallest}px;
  text-transform: uppercase;
`;

export default {
  HeaderContainer,
  NavLinkButton,
  HomeLinkIcon,
  Logo,
  LogOutLinkIcon,
  BpBarHeader,
  BpUserIcon,
  BpText,
  BpAlertIcon,
  BpAlertText,
  BpAlertHeader
};
